import React from "react";
import { Link } from "react-router-dom";
import "./style.css";

import { Routes } from "constants/index";

const StaticFooterComponent = () => {
  return (
    <div className="footer">
      <div className="container">
        <div className="row">
          <div className="col-12 col-sm-4 text-center text-sm-left">
            <p className="row-header h2">medoc</p>
            <address className="address my-4 my-sm-3 text-center text-sm-left d-none">
              1-4/7-19, KK Nagar, Vijayawada, <br />
              Andhra Pradesh <br />
              India - 520012
            </address>
            <b className="contact-email">contact@medoc.life</b> <br />
            <b className="contact-email">+91-(949)0086504</b>
          </div>
          <div className="col-12 col-sm-4 mt-4 my-sm-0 text-center text-sm-left">
            <ul className="row-list list-style-type-none">
              <li>
                <a href="/medical-certificate#faq" className="text-violet">
                  FAQ
                </a>
              </li>
              <li>
                <Link to={Routes.EMPLOYER_VERIFY} className="text-violet">
                  Employer Verify
                </Link>
              </li>
              <li>
                <a
                  href="/medical-certificate#section-two"
                  className="text-violet"
                >
                  How it works
                </a>
              </li>
              <li>
                <Link to={Routes.MEDICAL_CERTIFICATE} className="text-violet">
                  Get Medical Certificate
                </Link>
              </li>
              <li>
                <Link to={Routes.DOCTOR_CONSULTATION} className="text-violet">
                  Consult Doctor
                </Link>
              </li>
              <li>
                <Link to={Routes.MEDOC_GLOBAL} className="text-violet d-none">
                  Medoc Global
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-12 col-sm-4 text-center text-sm-left">
            <ul className="row-list">
              <li>
                <Link to={Routes.REFUND_POLICY} className="text-violet">
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link to={Routes.PRIVACY_POLICY} className="text-violet">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to={Routes.TNC} className="text-violet">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <a
                  href="https://www.trustpilot.com/review/medoc.life"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-violet"
                >
                  Leave a review
                </a>
              </li>
            </ul>
            <div className="text-center text-sm-left mb-3">
              Connect us at
              <a
                href="https://www.linkedin.com/company/medoc-offc"
                target="_blank"
                rel="noreferrer noopener"
                className="text-violet px-2"
                title="Linkedin"
              >
                <i className="fa fa-linkedin fs-22" />
              </a>
              <a
                href="https://www.instagram.com/medoc_life/"
                target="_blank"
                rel="noreferrer noopener"
                className="text-violet px-2"
                title="Instagram"
              >
                <i className="fa fa-instagram fs-22" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaticFooterComponent;
